/**
 * Created by Ning Jiang on 3/20/2017.
 */

import { ParsedInitData } from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import { BarbarianFuryServerDataParser } from "../BarbarianFuryServerDataParser";
import { IBarbarianFuryInitData } from "./IBarbarianFuryServerData";
import { BarbarianFuryGameMode } from "../../gamemode/BarbarianFuryGameMode";
import {FeatureBuyTimesBetValue} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class BarbarianFuryParsedInitData extends ParsedInitData {

    private readonly _freespinMultiplier: number;
    private readonly _initialStackOverlay: boolean[];
    private readonly _overlayWildInRespin: boolean[];
    private readonly _activeStackedSymbol: string;
    private readonly _wildMultipliersInRespin: number[];
    private readonly _wasFeatureBuy: boolean;
    private readonly _featureBuyTimesBetValue: FeatureBuyTimesBetValue[];

    constructor(rawData: IBarbarianFuryInitData, dataParser: BarbarianFuryServerDataParser) {
        super(rawData, dataParser);
        this._freespinMultiplier = rawData.freespinMultiplier;
        this._initialStackOverlay = dataParser.parseInitialStackOverlay(rawData);
        this._activeStackedSymbol = dataParser.parseActiveStackedSymbol(rawData);
        this._overlayWildInRespin = dataParser.parseOverlayWildInRespin(rawData);
        this._wildMultipliersInRespin = dataParser.parsewildMultipliersInRespin(rawData);
        this._wasFeatureBuy = rawData.wasFeatureBuy;
        this._featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
    }

    public get featureBuyTimesBetValue(): FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }
    public get wasFeatureBuy(): boolean {
        return this._wasFeatureBuy;
    }
    public get freeSpinMultiplier(): number {
        return this._freespinMultiplier;
    }
    public get initialStackOverlay(): boolean[] {
        return this._initialStackOverlay;
    }
    public get activeStackedSymbol(): string {
        return this._activeStackedSymbol;
    }
    public get overlayWildInRespin(): boolean[] {
        return this._overlayWildInRespin;
    }
    public get wildMultipliersInRespin(): number[] {
        return this._wildMultipliersInRespin;
    }

    //added below code for displaying total win in stacked respin.
    protected isFeatureTotalWin(): boolean {
        return (this.mode === BarbarianFuryGameMode.STACKED_RESPIN);
    }
}